export { default as coursesLocaleEn } from './localeEn';
export { default as coursesLocaleEs } from './localeEs';
export { default as coursesLocalePt } from './localePt';
